import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatNumber } from '../../common/helpers';
import TicketService from '../../domain/TicketService';
import gs from '../../styles/style';
import { Pager, SearchInput, TableLoader, useDataframe } from '../Common/Dataframe';
import DateTime from '../Common/DateTime';
import TicketNumber from './TicketNumber';
var FontAwesomeIcon = require('@fortawesome/react-fontawesome').FontAwesomeIcon;
var TicketOverview = function () {
    var t = useTranslation()[0];
    var dataframe = useDataframe(TicketService.getTickets, {
        perPage: 10
    });
    return React.createElement(Fragment, null,
        React.createElement("div", { className: gs('section-header') },
            React.createElement("h1", { className: gs('section-title') }, t('tickets'))),
        React.createElement("div", { className: gs('w-50') },
            React.createElement(SearchInput, { dataframe: dataframe })),
        React.createElement("table", { className: gs('table-overview', 'mt-4', { loading: dataframe.isLoading() }) },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { width: '20%' } }, t('ticket')),
                    React.createElement("th", { style: { width: '15%' } }, t('type')),
                    React.createElement("th", { style: { width: '30%' } }, t('customer')),
                    React.createElement("th", { style: { width: '15%' } }, t('draws')),
                    React.createElement("th", { style: { width: '20%' } }, t('created_at')))),
            React.createElement("tbody", null,
                React.createElement(TableLoader, { dataframe: dataframe, columns: 4 }),
                dataframe.getData().map(function (ticket) { return React.createElement("tr", { key: ticket.id },
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/tickets/".concat(ticket.id) },
                            React.createElement(TicketNumber, { number: ticket.number }))),
                    React.createElement("td", null, ticket.ticket_type.title),
                    React.createElement("td", null,
                        ticket.customer.name,
                        ' ',
                        ticket.customer.verified_at && React.createElement("small", { className: gs('text-success') },
                            React.createElement(FontAwesomeIcon, { icon: "check" })),
                        ticket.customer.rsu && React.createElement("small", { className: gs('text-muted') },
                            ' / ',
                            ticket.customer.rsu.title),
                        ticket.customer.external_id && React.createElement("small", { className: gs('text-muted') },
                            ' / ',
                            React.createElement("code", null, ticket.customer.external_id))),
                    React.createElement("td", null,
                        formatNumber(ticket.active_participations_count),
                        ' ',
                        ticket.participations_count > ticket.active_participations_count && React.createElement("small", { className: gs('text-muted') }, t('plus_inactive_count', { count: ticket.participations_count - ticket.active_participations_count }))),
                    React.createElement("td", null,
                        React.createElement(DateTime, { date: ticket.created_at }))); }))),
        dataframe.getPageCount() > 1 && React.createElement("div", { className: gs('mt-4') },
            React.createElement(Pager, { dataframe: dataframe })));
};
export default TicketOverview;
